import { withBooking } from 'components/queries/GetBookingQuery';
import { withUser } from 'components/queries/GetUserQuery';
import BookingPathReviewBooking from './BookingPathReviewBooking';

export default withUser(withBooking(BookingPathReviewBooking));
